module.exports = __webpack_public_path__ + "static/img/wm3.25f16c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wm3.png
// module id = ziE2
// module chunks = 1